// Bounded continuation east of Hachi. All raised artwork stays on existing solid buildings.
import type {HdBuilding,Rect} from '../../common/src/data';
import type {LightFn} from './hd-registry';
import {type G,K,HT,px,frame,bands,disc,alpha,text} from './hd-kit';
import {panel,label,fan,pipe,window} from './hd-hachi-study';
export const EAST_STUDY_BUILDINGS=['ks-noodle','ks-yakitori','ks-arcade','ks-oni-hq','ks-garage-w','ks-yard-wall','ks-garage-e'] as const;
function shutter(g:G,x:number,y:number,w:number,h:number){
 panel(g,x,y,w,h,K.metalLo);for(let j=4;j<h-3;j+=5){px(g,x+3,y+j,w-6,1,K.metalHi);px(g,x+3,y+j+1,w-6,1,K.ink);}
}
function grille(g:G,x:number,y:number,w:number,h:number){window(g,x,y,w,h,K.amber);for(let j=6;j<w-3;j+=8)px(g,x+j,y+2,2,h-4,K.metalLo);}
export function paintKabukiEastStudy(g:G,b:HdBuilding,x:number,y:number,L:LightFn){
 if(!(EAST_STUDY_BUILDINGS as readonly string[]).includes(b.id))return;
 const w=b.w*HT,h=b.h*HT,rh=(b.h-b.face)*HT,fy=y+rh;
 g.save();g.beginPath();g.rect(x,y,w,h);g.clip();
 if(b.id==='ks-yard-wall'){
  bands(g,x+2,fy,w-4,h-rh,K.concrete,K.concreteLo,5);
  for(let j=10;j<w-20;j+=63){shutter(g,x+j,fy+5,49,24);px(g,x+j+4,fy+7,41,2,K.amber);}
 }else{
  pipe(g,x+w-13,y+15,rh-26);
  if(['ks-noodle','ks-yakitori','ks-arcade'].includes(b.id)){
   const arcade=b.id==='ks-arcade',noodle=b.id==='ks-noodle',c=arcade?K.pink:K.amber;
   // Distinct kitchen extraction and arcade power plant, within the existing roof.
   panel(g,x+20,y+20,arcade?126:88,51,K.metalLo);
   fan(g,x+26,y+26);fan(g,x+62,y+26);
   if(arcade){fan(g,x+98,y+26);label(g,'POWER',x+w-100,y+30,75,K.white);}
   else{px(g,x+113,y+28,w-145,12,K.metalLo);px(g,x+115,y+29,w-149,3,K.metalHi);disc(g,x+w-37,y+34,12,7,K.metalHi);}
   bands(g,x+2,fy+2,w-4,h-rh-4,arcade?K.wall:K.woodHi,arcade?K.wallLo:K.woodLo,7);
   label(g,arcade?'ゲーム':noodle?'ラーメン':'ヤキトリ',x+21,fy+6,w-42,c,2);
   px(g,x+11,fy+37,w-22,9,K.ink);px(g,x+11,fy+37,w-22,2,c);
   if(arcade){
    for(let k=0;k<6;k++){const ax=x+23+k*55;panel(g,ax,fy+49,34,40,K.metalLo);window(g,ax+5,fy+53,24,18,k%2?K.amber:K.pink);px(g,ax+4,fy+75,26,5,K.metalHi);px(g,ax+9,fy+73,2,4,K.ink);px(g,ax+23,fy+76,3,2,K.pink);}
   }else{
    const dw=48,dx=x+w/2-dw/2;
    for(const wx of [x+18,x+w/2+36]){window(g,wx,fy+49,w/2-55,36,K.amber);px(g,wx+4,fy+74,w/2-63,4,K.woodHi);
     for(let k=10;k<w/2-62;k+=23){if(noodle){disc(g,wx+k,fy+70,7,3,K.white);px(g,wx+k-4,fy+71,8,3,K.metalLo);}else{px(g,wx+k,fy+59,1,15,K.woodHi);for(let j=0;j<3;j++)px(g,wx+k-2,fy+60+j*4,5,3,K.amber);}}
    }
    panel(g,dx,fy+47,dw,46,K.woodLo);for(let j=0;j<4;j++){px(g,dx+2+j*12,fy+47,10,20,K.woodLo);px(g,dx+3+j*12,fy+48,8,2,K.amber);}
   }
   L(x+25,fy+12,w-50,18,c,.22,true);
  }else if(b.id==='ks-oni-hq'){
   panel(g,x+28,y+82,131,92,K.concreteLo);grille(g,x+38,y+94,47,36);shutter(g,x+100,y+96,43,61);
   for(let j=0;j<4;j++){px(g,x+180+j*25,y+121,19,62,K.metalLo);px(g,x+182+j*25,y+123,3,58,K.metalHi);}
   px(g,x+29,y+194,w-58,5,K.metalLo);for(let j=30;j<w-30;j+=27)px(g,x+j,y+183,3,17,K.metalHi);
   bands(g,x+2,fy+2,w-4,h-rh-4,K.wall,K.wallLo,8);
   for(let j=0;j<4;j++)grille(g,x+22+j*75,fy+10,51,30);
   label(g,'ONI',x+89,fy+47,w-178,K.pink,3);
   for(const xx of [x+23,x+w-76]){shutter(g,xx,fy+56,53,63);px(g,xx+4,fy+62,45,3,K.pink);}
   panel(g,x+w/2-30,fy+85,60,39,K.ink);px(g,x+w/2-1,fy+89,2,31,K.metal);px(g,x+w/2+15,fy+102,3,3,K.amber);
   L(x+95,fy+53,w-190,22,K.pink,.25,true);
  }else{
   const narrow=b.id==='ks-garage-e';
   panel(g,x+18,y+77,w-36,71,K.metalLo);for(let j=0;j<3;j++){px(g,x+23,y+86+j*18,w-46,10,K.metal);px(g,x+23,y+86+j*18,w-46,2,K.metalHi);}
   fan(g,x+24,y+175);pipe(g,x+w-32,y+156,61);
   bands(g,x+2,fy+2,w-4,h-rh-4,K.concrete,K.wallLo,8);
   label(g,narrow?'LOTUS':'RUST LOTUS',x+9,fy+7,w-18,K.amber,2);
   const bx=x+17,bw=w-34;shutter(g,bx,fy+39,bw,32);panel(g,bx,fy+70,bw,51,K.ink);
   // A recessed workbench and lift silhouettes belong to the facade, not the driveable yard.
   for(const xx of [bx+7,bx+bw-12]){px(g,xx,fy+74,5,43,K.metalHi);px(g,xx-2,fy+94,12,4,K.amber);}
   px(g,bx+18,fy+91,bw-36,5,K.woodHi);for(let j=25;j<bw-20;j+=17){px(g,bx+j,fy+79,2,10,K.metalHi);px(g,bx+j-2,fy+78,6,2,K.metalHi);}
   for(let j=5;j<bw-5;j+=12)px(g,bx+j,fy+120,7,3,K.amber);
   L(x+14,fy+13,w-28,19,K.amber,.23,true);
  }
 }
 px(g,x+2,y+h-4,w-4,3,K.ink);g.restore();
}
export function paintKabukiEastGround(g:G,R:Rect){
 const x0=Math.max(82,R.x),x1=Math.min(114,R.x+R.w),y0=Math.max(68,R.y),y1=Math.min(82,R.y+R.h);if(x1<=x0||y1<=y0)return;
 const X=(n:number)=>(n-R.x)*HT,Y=(n:number)=>(n-R.y)*HT;
 g.save();g.beginPath();g.rect(X(x0),Y(y0),(x1-x0)*HT,(y1-y0)*HT);g.clip();
 // Flat drainage in Oni street; leave the middle of the lane open and readable.
 px(g,X(82),Y(68)+5,32*HT,3,alpha(K.ink,.4));for(let tx=84;tx<114;tx+=6){panel(g,X(tx),Y(68)+9,32,7,K.metalLo);for(let j=4;j<29;j+=5)px(g,X(tx)+j,Y(68)+10,2,5,K.ink);}
 // Worn bay lines only. Existing shop counter and all collision remain authoritative.
 for(const tx of [101,108]){px(g,X(tx),Y(73),2,8*HT,alpha(K.amber,.28));for(let ty=74;ty<81;ty+=2)px(g,X(tx)-2,Y(ty),6,11,K.night);}
 for(const tx of [102,107])for(let j=0;j<10;j++)px(g,X(tx)+j%2*3,Y(74)+j*20,5,14,alpha(K.ink,.25));
 frame(g,X(104),Y(80),2*HT,17,alpha(K.metalHi,.3));text(g,'SERVICE',X(103),Y(73)+7,alpha(K.white,.22),1);
 g.restore();
}
